// extracted by mini-css-extract-plugin
export default {"Button":"RequestDiagnosticsModal_Button__-aILn","Container":"RequestDiagnosticsModal_Container__nuiLX","DateText":"RequestDiagnosticsModal_DateText__2Wn5i"};